(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function initJudgeMeStarFix() {
    function applyJudgeMeStarFix(root) {
      try {
        (root || document).querySelectorAll('.jm-star-rating__font-icon').forEach(function (el) {
          el.style.fontFamily = 'JudgemeStar';
          el.style.fontStyle = 'normal';
          el.style.fontWeight = '400';
          el.style.lineHeight = '1';
          el.style.display = 'inline-block';
          el.style.letterSpacing = '0';
          el.style.webkitFontSmoothing = 'antialiased';
        });
      } catch (e) {}
    }

    applyJudgeMeStarFix(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (!m.addedNodes) return;
        m.addedNodes.forEach(function (node) {
          if (node && node.nodeType === 1) applyJudgeMeStarFix(node);
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function initHeroSlideshows(root) {
    (root || document).querySelectorAll('[data-nl-hero-slideshow]').forEach(function (media) {
      if (media.dataset.nlHeroSlideshowInit === 'true') return;
      media.dataset.nlHeroSlideshowInit = 'true';

      var slides = Array.prototype.slice.call(media.querySelectorAll('[data-nl-hero-slide]'));
      if (slides.length < 2) return;

      var current = Math.max(0, slides.findIndex(function (slide) { return slide.classList.contains('is-active'); }));
      var duration = parseInt(media.dataset.slideDuration, 10) || 5000;
      var speed = parseInt(media.dataset.transitionSpeed, 10) || 600;
      var autoplay = media.dataset.autoplay !== 'false';
      var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = null;
      var dots = Array.prototype.slice.call(media.querySelectorAll("[data-nl-hero-dot]"));
      var pause = media.querySelector("[data-nl-hero-pause]");
      var paused = !autoplay || prefersReduced;

      media.style.setProperty('--nl-hero-transition-speed', speed + 'ms');

      function activate(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle('is-active', slideIndex === current);
          slide.setAttribute('aria-hidden', slideIndex === current ? 'false' : 'true');
          if (dots[slideIndex]) dots[slideIndex].setAttribute('aria-pressed', slideIndex === current ? 'true' : 'false');
        });
      }

      function stop() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        stop();
        if (paused) return;
        timer = window.setInterval(function () {
          activate(current + 1);
        }, duration);
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () { stop(); activate(index); });
      });
      function updatePause() {
        if (!pause) return;
        pause.setAttribute('aria-label', paused ? pause.dataset.playLabel : pause.dataset.pauseLabel);
        pause.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
      }
      if (pause) pause.addEventListener('click', function () {
        paused = !paused;
        updatePause();
        if (paused) stop(); else start();
      });
      updatePause();
      media.addEventListener('mouseenter', stop);
      media.addEventListener('mouseleave', start);
      media.addEventListener('focusin', stop);
      media.addEventListener('focusout', start);

      media.addEventListener('shopify:block:select', function (event) {
        var selectedSlide = event.target && event.target.closest ? event.target.closest('[data-nl-hero-slide]') : null;
        var selectedIndex = selectedSlide ? slides.indexOf(selectedSlide) : -1;
        if (selectedIndex > -1) {
          stop();
          activate(selectedIndex);
        }
      });

      media.addEventListener('shopify:block:deselect', start);
      activate(current);
      start();
    });
  }

  function initHeroAnimations() {
    document.querySelectorAll('.nl-section-hero').forEach(function (section) {
      if (section.dataset.nlPwHeroInit === 'true') return;
      section.dataset.nlPwHeroInit = 'true';

      var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReduced || typeof window.gsap === 'undefined') return;

      var heading = section.querySelector('[data-nl-hero-heading]');
      var label = section.querySelector('[data-nl-hero-label]');
      var subheading = section.querySelector('[data-nl-hero-subheading]');
      var ctas = section.querySelector('[data-nl-hero-ctas]');
      var media = section.querySelector('[data-nl-hero-media]');

      if (heading && heading.dataset.nlPwWrapped !== 'true') {
        var innerEl = heading.querySelector('p') || heading;
        var html = innerEl.innerHTML;
        var words = [];
        var buffer = '';
        var inTag = false;
        for (var i = 0; i < html.length; i++) {
          var ch = html[i];
          if (ch === '<') { inTag = true; buffer += ch; }
          else if (ch === '>') { inTag = false; buffer += ch; }
          else if (ch === ' ' && !inTag) {
            if (buffer.length > 0) { words.push(buffer); buffer = ''; }
          } else {
            buffer += ch;
          }
        }
        if (buffer.length > 0) words.push(buffer);
        innerEl.innerHTML = words.map(function (w) {
          return '<span class="nl-hero__word" style="display:inline-block">' + w + '</span>';
        }).join(' ');
        heading.dataset.nlPwWrapped = 'true';

        window.gsap.from(innerEl.querySelectorAll('.nl-hero__word'), {
          y: 40,
          opacity: 0,
          duration: 0.6,
          ease: 'power3.out',
          stagger: 0.08
        });
      }

      var fadeEls = [label, subheading, ctas].filter(Boolean);
      if (fadeEls.length) {
        window.gsap.from(fadeEls, {
          y: 30,
          opacity: 0,
          duration: 0.7,
          ease: 'power3.out',
          stagger: 0.12,
          delay: 0.4
        });
      }

      if (media) {
        window.gsap.from(media, {
          x: 40,
          opacity: 0,
          duration: 0.9,
          ease: 'power3.out',
          delay: 0.3
        });
      }
    });
  }

  function initSocialProofCounters() {
    function parseNumber(str) {
      var cleaned = String(str || '').replace(/,/g, '');
      var match = cleaned.match(/^[\d.]+/);
      return match ? parseFloat(match[0]) : null;
    }

    function formatNumber(val, originalStr) {
      var cleaned = String(originalStr || '').replace(/,/g, '');
      var match = cleaned.match(/^[\d.]+/);
      if (!match) return originalStr;
      var hasDecimal = originalStr.indexOf('.') !== -1;
      return String(originalStr).replace(match[0], hasDecimal ? val.toFixed(1) : Math.round(val).toLocaleString('en-US'));
    }

    function animateCounter(el, targetStr, duration) {
      var targetNum = parseNumber(targetStr);
      if (targetNum === null) return;
      var startTime = null;
      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var current = targetNum * eased;
        el.textContent = formatNumber(current, targetStr);
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = targetStr;
      }
      requestAnimationFrame(step);
    }

    document.querySelectorAll('.nl-social-proof-strip').forEach(function (sectionEl) {
      if (sectionEl.dataset.nlPwInit === 'true') return;
      sectionEl.dataset.nlPwInit = 'true';
      var metrics = sectionEl.querySelectorAll('[data-metric-block]');
      if (!metrics.length || typeof IntersectionObserver === 'undefined') return;
      var triggered = false;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || triggered) return;
          triggered = true;
          observer.disconnect();
          metrics.forEach(function (metric, index) {
            setTimeout(function () {
              metric.classList.add('is-visible');
              var numberEl = metric.querySelector('[data-counter-target]');
              if (numberEl) animateCounter(numberEl, numberEl.getAttribute('data-counter-target'), 1400);
            }, index * 120);
          });
        });
      }, { threshold: 0.25 });
      observer.observe(sectionEl);
    });
  }

  function initFeaturedProducts() {
    document.querySelectorAll('.nl-featured-product[data-section-id]').forEach(function (section) {
      if (section.dataset.nlPwInit === 'true') return;
      section.dataset.nlPwInit = 'true';
      if (typeof IntersectionObserver === 'undefined') return;
      var specs = section.querySelectorAll('.nl-featured-product__spec');
      if (!specs.length) return;
      specs.forEach(function (spec, i) {
        spec.style.opacity = '0';
        spec.style.transform = 'translateY(16px)';
        spec.style.transition = 'opacity 0.4s ease ' + (i * 0.06) + 's, transform 0.4s ease ' + (i * 0.06) + 's';
      });
      var specsGrid = section.querySelector('.nl-featured-product__specs');
      if (!specsGrid) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.querySelectorAll('.nl-featured-product__spec').forEach(function (spec) {
            spec.style.opacity = '1';
            spec.style.transform = 'translateY(0)';
          });
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.15 });
      observer.observe(specsGrid);
    });
  }

  function initBrandStory() {
    document.querySelectorAll('.nl-brand-story[data-section-id]').forEach(function (section) {
      if (section.dataset.nlPwInit === 'true') return;
      section.dataset.nlPwInit = 'true';
      if (typeof IntersectionObserver === 'undefined') return;
      var animTargets = [].concat(
        Array.from(section.querySelectorAll('.nl-brand-story__label')),
        Array.from(section.querySelectorAll('.nl-brand-story__heading')),
        Array.from(section.querySelectorAll('.nl-brand-story__body')),
        Array.from(section.querySelectorAll('.nl-brand-story__stats')),
        Array.from(section.querySelectorAll('.nl-brand-story__image-wrap'))
      );
      animTargets.forEach(function (el, i) {
        el.style.opacity = '0';
        el.style.transform = 'translateY(20px)';
        el.style.transition = 'opacity 0.5s ease ' + (i * 0.08) + 's, transform 0.5s ease ' + (i * 0.08) + 's';
      });
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          animTargets.forEach(function (el) {
            el.style.opacity = '1';
            el.style.transform = 'translateY(0)';
          });
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.1 });
      observer.observe(section);
    });
  }

  function initEmailCapture() {
    document.querySelectorAll('.nl-email-capture[data-section-id]').forEach(function (section) {
      if (section.dataset.nlPwInit === 'true') return;
      section.dataset.nlPwInit = 'true';
      var successEl = section.querySelector('.nl-email-capture__success');
      var formEl = section.querySelector('.nl-email-capture__form');
      var postedEl = section.querySelector('[data-posted="true"]');
      if (postedEl) {
        if (formEl) formEl.style.display = 'none';
        if (successEl) successEl.classList.add('is-visible');
      }
    });
  }

  function initProductLineup() {
    var hasTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
    if (!hasTouch) return;
    document.querySelectorAll('.nl-product-lineup').forEach(function (section) {
      section.classList.add('nl-product-lineup--touch');
    });
  }

  function initProductRecommendations() {
    document.querySelectorAll('.nl-product-recs').forEach(function (sectionEl) {
      if (sectionEl.dataset.nlPwInit === 'true') return;
      sectionEl.dataset.nlPwInit = 'true';

      var productId = sectionEl.dataset.productId;
      var limit = sectionEl.dataset.limit || '4';
      var hasGrid = sectionEl.querySelector('.nl-product-recs__grid:not(.nl-product-recs__grid--skeleton)');
      if (hasGrid) {
        var innerReady = sectionEl.querySelector('.nl-product-recs__inner');
        if (innerReady) innerReady.setAttribute('aria-busy', 'false');
        return;
      }
      if (!productId || productId === '0') {
        sectionEl.classList.add('nl-product-recs--empty');
        return;
      }

      var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      var url = shopRoot + 'recommendations/products?product_id=' + encodeURIComponent(productId) + '&limit=' + encodeURIComponent(limit) + '&section_id=nl-product-recommendations';
      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error('Recommendations fetch failed: ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var parser = document.createElement('div');
          parser.innerHTML = html;
          var newInner = parser.querySelector('.nl-product-recs__inner');
          if (!newInner) {
            sectionEl.classList.add('nl-product-recs--empty');
            return;
          }
          var cards = newInner.querySelectorAll('.nl-product-recs__card');
          if (!cards.length) {
            sectionEl.classList.add('nl-product-recs--empty');
            return;
          }
          var currentInner = sectionEl.querySelector('.nl-product-recs__inner');
          if (currentInner) {
            currentInner.innerHTML = newInner.innerHTML;
            currentInner.setAttribute('aria-busy', 'false');
          }
        })
        .catch(function (err) {
          console.warn('[NL Recommendations] Error:', err);
          sectionEl.classList.add('nl-product-recs--empty');
        });
    });
  }

  function initRecentlyViewed() {
    var STORAGE_KEY = 'nl_recently_viewed';
    var MAX_STORED = 10;

    function formatMoney(cents) {
      var numeric = Number(cents) || 0;
      if (window.Shopify && window.Shopify.money_format) {
        return window.Shopify.money_format.replace('{{amount}}', (numeric / 100).toFixed(2));
      }
      return '$' + (numeric / 100).toFixed(2);
    }

    function saveHandle(handle) {
      if (!handle) return;
      var list;
      try {
        list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        if (!Array.isArray(list)) list = [];
      } catch (e) {
        list = [];
      }
      list = list.filter(function (h) { return h !== handle; });
      list.unshift(handle);
      if (list.length > MAX_STORED) list = list.slice(0, MAX_STORED);
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      } catch (e) {}
    }

    document.querySelectorAll('.nl-rv').forEach(function (sectionEl) {
      if (sectionEl.dataset.nlPwInit === 'true') return;
      sectionEl.dataset.nlPwInit = 'true';

      var currentHandle = sectionEl.dataset.currentHandle || '';
      var maxDisplay = parseInt(sectionEl.dataset.max, 10) || 8;
      var track = sectionEl.querySelector('.nl-rv__track');
      if (!track) return;

      saveHandle(currentHandle);

      var handles;
      try {
        handles = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        if (!Array.isArray(handles)) handles = [];
      } catch (e) {
        handles = [];
      }
      handles = handles.filter(function (h) { return h !== currentHandle; }).slice(0, maxDisplay);
      if (!handles.length) {
        sectionEl.classList.add('nl-rv--empty');
        return;
      }

      function buildCardHTML(prod) {
        var image = prod.images && prod.images.length > 0 ? prod.images[0] : null;
        var imgSrc = image ? image.src : '';
        var imgAlt = (image && image.alt) ? image.alt : prod.title;
        var price = prod.variants && prod.variants.length > 0 ? Number(prod.variants[0].price) : 0;
        var compare = prod.variants && prod.variants.length > 0 ? Number(prod.variants[0].compare_at_price) : null;
        var priceFormatted = formatMoney(Math.round(price * 100));
        var compareFormatted = compare ? formatMoney(Math.round(compare * 100)) : '';
        function esc(str) {
          return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#x27;');
        }
        var imageMarkup = imgSrc
          ? '<img class="nl-rv__card-image" src="' + esc(imgSrc) + '" alt="' + esc(imgAlt) + '" loading="lazy" width="200" height="200">'
          : '<div class="nl-rv__card-placeholder" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" width="32" height="32"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></div>';
        var vendorMarkup = prod.vendor ? '<p class="nl-rv__card-vendor">' + esc(prod.vendor) + '</p>' : '';
        var compareMarkup = (compare && compare > price) ? '<s class="nl-rv__card-price-compare">' + esc(compareFormatted) + '</s>' : '';
        return '<div class="nl-rv__card">'
          + '<a class="nl-rv__card-link" href="/products/' + esc(prod.handle) + '" aria-label="' + esc(prod.title) + '">'
          + '<div class="nl-rv__card-image-wrap">' + imageMarkup + '</div>'
          + '<div class="nl-rv__card-body">'
          + vendorMarkup
          + '<h3 class="nl-rv__card-title">' + esc(prod.title) + '</h3>'
          + '<p class="nl-rv__card-price"><span class="nl-rv__card-price-current">' + esc(priceFormatted) + '</span>' + compareMarkup + '</p>'
          + '</div></a></div>';
      }

      Promise.all(handles.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function (response) { if (!response.ok) throw new Error('Product fetch failed: ' + response.status); return response.json(); })
          .catch(function () { return null; });
      }))
      .then(function (products) {
        var validProducts = products.filter(Boolean);
        if (!validProducts.length) {
          sectionEl.classList.add('nl-rv--empty');
          return;
        }
        track.innerHTML = validProducts.map(buildCardHTML).join('');
        track.setAttribute('aria-busy', 'false');
      })
      .catch(function (err) {
        console.warn('[NL Recently Viewed] Error:', err);
        sectionEl.classList.add('nl-rv--empty');
      });
    });
  }

  onReady(function () {
    initJudgeMeStarFix();
    initHeroSlideshows();
    initHeroAnimations();
    initSocialProofCounters();
    initFeaturedProducts();
    initBrandStory();
    initEmailCapture();
    initProductLineup();
    initProductRecommendations();
    initRecentlyViewed();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initHeroSlideshows(event.target);
    initHeroAnimations();
  });
})();
